import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 264 107",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M186 27C186 34.0914 184.603 41.1133 181.889 47.6649C179.176 54.2165 175.198 60.1694 170.184 65.1838C165.169 70.1981 159.216 74.1757 152.665 76.8895C146.113 79.6032 139.091 81 132 81C124.909 81 117.887 79.6033 111.335 76.8895C104.784 74.1757 98.8306 70.1981 93.8162 65.1838C88.8019 60.1694 84.8243 54.2165 82.1105 47.6649C79.3967 41.1133 78 34.0914 78 27L186 27Z",
      fill: "var(--dt-color-surface-moderate)",
      id: "avatar-shape"
    }, null, -1),
    _createElementVNode("path", {
      d: "M178 67.5C178 72.1467 174.02 76 169 76C163.98 76 160 72.1467 160 67.5C160 62.8533 163.98 59 169 59C174.02 59 178 62.8533 178 67.5Z",
      fill: "var(--dt-color-surface-success-strong)",
      stroke: "var(--dt-color-foreground-primary-inverted)",
      "stroke-width": "2",
      id: "Ellipse 68"
    }, null, -1)
  ]))]))
}
export default { render: render }